import { Button, CircularProgress, Typography } from "@suraasa/placebo-ui"
import MysteryBox from "assets/Fallback/mystery-box.svg"
import clsx from "clsx"
import SimpleCard from "components/SimpleCard"
import React from "react"

type Props = {
  data?: {
    image?: string
    title: string
    description?: string
  }
  isLoading?: boolean
  hasError?: boolean
  children?: React.ReactNode
  isEmpty?: boolean
  className?: string
  emptyMessage?: string
}

const Fallback = ({
  data,
  isLoading,
  hasError,
  children,
  className,
  emptyMessage = "No data available",
  isEmpty,
}: Props) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-4">
        <CircularProgress />
      </div>
    )
  }

  const imageSrc = data?.image || MysteryBox

  if (isEmpty) {
    return <SimpleCard>{emptyMessage}</SimpleCard>
  }

  if (hasError) {
    return (
      <div className={clsx(className)}>
        <img src={imageSrc} alt="svg-logo" className="mx-auto mb-3" />
        <div
          style={{
            maxWidth: 450,
          }}
          className="mx-auto"
        >
          <Typography variant="title3" className="mb-1 text-center">
            It seems that there has been some issue!
            <Button
              variant="text"
              onClick={() => {
                window.location.reload()
              }}
            >
              Refresh the page
            </Button>
            or try again later.
          </Typography>
        </div>
      </div>
    )
  }
  if (data) {
    return (
      <>
        <div className={className}>
          <img src={imageSrc} alt="svg-logo" className="mx-auto mb-3" />
          <div
            style={{
              maxWidth: 450,
            }}
            className="mx-auto"
          >
            <Typography variant="title3" className="mb-1 text-center">
              {data.title}
            </Typography>
            {data.description && (
              <Typography
                variant="smallBody"
                className="text-center text-onSurface-500"
              >
                {data.description}
              </Typography>
            )}
          </div>
        </div>
        {children}
      </>
    )
  }
  return null
}

export default Fallback
